import React, { useCallback } from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/SEO';
import SiteLayout from '../components/SiteLayout';
import Hero from '../components/Solutions/Hero';
import Menu from '../components/Solutions/Menu';
import ContentBlocks from '../components/Solutions/ContentBlocks';
import ReadyToStartCTA from '../components/CTA/ReadyToStart';
import LookingForMoreCTA from '../components/CTA/LookingForMore';
import { StyledCTA } from '../components/Solutions/styles';

const Tier2Template = ({
  location,
  data: {
    wpgraphql: {
      pageBy: {
        ancestors,
        acfSolutionsTier1And2: { hero, contentBlocks },
        ...page
      },
    },
  },
}) => {
  // fix order of ancestors
  const sortedAncestors = ancestors.nodes;
  function compare( a, b ) {
    if ( a.uri.length > b.uri.length ){
      return -1;
    }
    if ( a.uri.length < b.uri.length ){
      return 1;
    }
    return 0;
  }
  sortedAncestors.sort(compare);

  const printCTA = useCallback(() => {
    switch (sortedAncestors[0].slug) {
      case 'expert-services':
        return <LookingForMoreCTA />;
      case 'email-api':
        return <ReadyToStartCTA theme="darkest-blue" />;
      default:
        return <ReadyToStartCTA />;
    }
  }, [sortedAncestors[0].slug]);

  return (
    <SiteLayout location={location}>
      <SEO page={page} path={location.pathname} />
      <Hero hero={hero}>
        <Menu menu={sortedAncestors[0].acfSolutionsNavigation} overviewUri={sortedAncestors[0].uri} pageUri={page.uri} />
      </Hero>
      <ContentBlocks blocks={contentBlocks} />
      <StyledCTA>{printCTA()}</StyledCTA>
    </SiteLayout>
  );
};

export default Tier2Template;

export const query = graphql`
  query GET_TIER1AND2($id: ID!) {
    wpgraphql {
      pageBy(id: $id) {
        uri
        ancestors {
          nodes {
            slug
            uri
            ...MenuFragment
          }
        }
        ...SEOPageFragment
        ...HeroFragment
        ...MediaAndTextFragment
        ...TypesOfPackagesFragment
        ...TabbedCodeExamplesFragment
        ...FeaturesFragment
        ...IconCardsFragment
        ...StatisticsFragment
        ...CalloutColumnsFragment
        ...FrequentlyAskedQuestionsFragment
        ...ContactFormTier1And2Fragment
      }
    }
  }
`;
